import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { PositionState } from "@reducers/types/HRM/position-state";

import {
  createPositionRequest,
  getPositionRequest,
  updatePositionRequest,
} from "@actions/HRM/position/position-action";
import { getPositionState } from "@selectors/HRM/position/position-selectors";

import { useAppSelector } from "@helpers/redux";
import { PositionCreateType, PositionType } from "@type/HRM/position";

interface UsePosition {
  position: PositionType;
  createPosition: (newPosition: any) => void;
  updatePosition: (newPosition: any) => void;
  isGetPositionRequest: boolean;
  isGetPositionSuccess: boolean;
  isGetPositionFailed: boolean;
  isCreatePositionRequest: boolean;
  isCreatePositionSuccess: boolean;
  isCreatePositionFailed: boolean;
  isUpdatePositionRequest: boolean;
  isUpdatePositionSuccess: boolean;
  isUpdatePositionFailed: boolean;
}

export const usePosition = (id?: number | null): UsePosition => {
  const dispatch = useDispatch();

  const getPosition = useAppSelector<PositionState>(getPositionState);

  const isGetPositionRequest = getPosition.getRequest as boolean;
  const isGetPositionSuccess = getPosition.getSuccess as boolean;
  const isGetPositionFailed = getPosition.getFailed as boolean;
  const isCreatePositionRequest = getPosition.createRequest as boolean;
  const isCreatePositionSuccess = getPosition.createSuccess as boolean;
  const isCreatePositionFailed = getPosition.createFailed as boolean;
  const isUpdatePositionRequest = getPosition.updateRequest as boolean;
  const isUpdatePositionSuccess = getPosition.updateSuccess as boolean;
  const isUpdatePositionFailed = getPosition.updateFailed as boolean;
  const position = getPosition.data || ({} as PositionType);

  //GET
  useEffect(() => {
    if (id) dispatch(getPositionRequest(id));
  }, [dispatch, id]);

  //CREATE
  const createPosition = (newPosition: PositionCreateType) =>
    dispatch(createPositionRequest(newPosition));

  //UPDATE
  const updatePosition = (updatePosition: PositionCreateType) =>
    dispatch(
      updatePositionRequest({
        id,
        ...updatePosition,
      })
    );

  return {
    position,
    createPosition,
    updatePosition,
    isGetPositionRequest,
    isGetPositionSuccess,
    isGetPositionFailed,
    isCreatePositionRequest,
    isCreatePositionSuccess,
    isCreatePositionFailed,
    isUpdatePositionRequest,
    isUpdatePositionSuccess,
    isUpdatePositionFailed,
  };
};
